import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { Text } from '@naf/text';

export const CtaActivateButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CTAWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.space16};
`;

export const DiscountInfoText = styled(Text)`
  margin-bottom: ${spacing.space32};
`;
